import Layout from "../../../components/layout/layout.js";

import NotificationManager from "../../../components/dashboard/NotificationManager.js";


function notificationManagerPage({ component, ...rest }) {
  return <Layout Component={NotificationManager} {...rest} controlsDisabled={true} />;
}

export default notificationManagerPage;
